import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=cf760f14&scoped=true&"
import script from "./UpgradeButton.vue?vue&type=script&lang=js&"
export * from "./UpgradeButton.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeButton.vue?vue&type=style&index=0&id=cf760f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf760f14",
  null
  
)

export default component.exports